import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";
import { Navigate, Outlet } from "react-router-dom";

import { clearErrorCollaborator } from "../redux/slices/collaboratorSlice";
import { clearErrorProject } from "../redux/slices/projectSlice";
import { clearErrorUser } from "../redux/slices/userSlice";

import Header from "../components/UI/Header/Header";

const AuthenticatedRoute = ({ user, isAdminRoute }) => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearErrorCollaborator());
    dispatch(clearErrorProject());
    dispatch(clearErrorUser());
  }, [dispatch, location.pathname]);

  if (!user || user.is_admin !== isAdminRoute) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return (
    <>
      <Header />
      <Outlet />
    </>
  );
};

export default AuthenticatedRoute;
